export default __webpack_public_path__ + "static/738-e7962a3e08f2fb3d956f80dc19e85542.gif";